import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { PaymentPackage } from '../../models/payment/payment-package';


@Component({
  selector:    'red-payment-table',
  templateUrl: './payment-table.component.html',
  styleUrls:   [ './payment-table.component.scss' ]
})
export class PaymentTableComponent implements OnInit {

  @Input() public packages: PaymentPackage[];

  @Output() public packageAction: EventEmitter<PaymentPackage>;
  @Output() public couponApplied: EventEmitter<{ coupon: string, packageId: number }>;

  constructor() {
    this.packageAction = new EventEmitter<PaymentPackage>();
    this.couponApplied = new EventEmitter<{ coupon: string, packageId: number }>();
  }

  ngOnInit(): void {
  }

  public couponAppliedAction(
    coupon:         string,
    paymentPackage: PaymentPackage
  ) {
    this.couponApplied.emit({ coupon, packageId: paymentPackage.id });
  }

  public action(paymentPackage: PaymentPackage, event?: Event) {
    if (event) event.preventDefault();
    this.packageAction.emit(paymentPackage);
  }

}
